//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    handleColorful: function handleColorful() {
      this.$log.colorful([{
        text: 'H',
        type: 'default'
      }, {
        text: 'e',
        type: 'primary'
      }, {
        text: 'l',
        type: 'success'
      }, {
        text: 'l',
        type: 'warning'
      }, {
        text: 'o',
        type: 'danger'
      }]);
    }
  }
};